import * as Sentry from '@sentry/browser'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import moment from 'moment'

import { persistor } from 'store'
import { isResponseFailed } from 'helpers/responseHelpers'
import { userInfoFromHash } from 'store/entities/router/selectors'
import { sendError } from 'store/entities/analytics/actions'
import { ERRORS } from 'store/entities/analytics/consts'
import { authLogin, processEmailQuery } from '../actions'
import { INVALID_TOKEN_PARAM, SELECT_NEW_PROTRACK_PARAM } from 'app/constants/loginErrors'

export function* processEmailQueryHandler() {
  try {
    const query = yield select(userInfoFromHash)
    if (!query || !query.has('token') || !query.has('uid')) {
      yield put(push('/'))
      return
    }
    const token = query.get('token')
    const isValidToken = token.length === 36
    if (!isValidToken) {
      Sentry.withScope(scope => {
        scope.setExtra('where error was happen', 'processEmailQuery saga')
        scope.setExtra('query', JSON.stringify(query.toJS()))
        scope.setExtra('token', token)
        Sentry.captureException('INVALID TOKEN CAME ON UI')
      })
    }

    // 1. calling flush persistor each time when login from link
    yield call(persistor.flush)

    // 2. login
    const response = yield authLogin.call({
      data: { token, email: query.get('uid'), timezone: moment.tz.guess() },
      flagForErrorMessage:
        (!isValidToken && INVALID_TOKEN_PARAM) ||
        query.get('action') ||
        (query.get(SELECT_NEW_PROTRACK_PARAM) && SELECT_NEW_PROTRACK_PARAM),
    })
    if (isResponseFailed(response)) {
      throw response
    }
  } catch (error) {
    yield put(
      sendError({
        type: ERRORS.PROCESS_EMAIL_QUERY,
        error,
      })
    )
    yield put(push('/'))
  }
}

export default function* processEmailQuerySaga() {
  yield takeEvery(processEmailQuery.toString(), processEmailQueryHandler)
}
